export class String {
    // eslint-disable-next-line
    public static format(text: string, ...args: Array<any>): string {
        for (const k in args) {
            text = text.replace(new RegExp('\\{' + k + '\\}', 'g'), args[k]);
        }
        return text;
    }
}
